import apiInstance from '../utils/axiosConfig';

const UserService = {
    // Créer un utilisateur
    createUser: async (userRequestDTO) => {
        try {
            const response = await apiInstance.post('/users/create', userRequestDTO);
            return response.data;
        } catch (error) {
            console.error('Error creating user:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un utilisateur
    updateUser: async (id, userRequestDTO) => {
        try {
            const response = await apiInstance.put(`/users/update/${id}`, userRequestDTO);
            return response.data;
        } catch (error) {
            console.error('Error updating user:', error.message || error);
            throw error;
        }
    },

    // Changer le mot de passe d'un utilisateur
    changePassword: async (id, changePasswordRequest) => {
        try {
            await apiInstance.put(`/users/change-password/${id}`, changePasswordRequest);
        } catch (error) {
            console.error('Error changing password:', error.message || error);
            throw error;
        }
    },

    // Supprimer un utilisateur
    deleteUser: async (id) => {
        try {
            await apiInstance.delete(`/users/delete/${id}`);
        } catch (error) {
            console.error('Error deleting user:', error.message || error);
            throw error;
        }
    },

    // Récupérer un utilisateur par ID
    getUserById: async (id) => {
        try {
            const response = await apiInstance.get(`/users/getId/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les utilisateurs avec pagination
    getAllUsers: async (pageable) => {
        try {
            const response = await apiInstance.get(`/users/getAll`, { params: pageable });
            return response.data;
        } catch (error) {
            console.error('Error fetching all users:', error.message || error);
            throw error;
        }
    },

    // Rechercher des utilisateurs par terme de recherche
    searchUsers: async (searchTerm) => {
        try {
            const response = await apiInstance.get(`/users/search`, { params: { searchTerm } });
            return response.data;
        } catch (error) {
            console.error('Error searching users:', error.message || error);
            throw error;
        }
    },

    // Envoyer un jeton de réinitialisation de mot de passe
    sendPasswordResetToken: async (passwordResetRequest) => {
        try {
            await apiInstance.post('/users/reset-password/send-mail', passwordResetRequest);
        } catch (error) {
            console.error('Error sending password reset token:', error.message || error);
            throw error;
        }
    },

    // Réinitialiser le mot de passe
    resetPassword: async (passwordResetConfirmRequest) => {
        try {
            await apiInstance.post('/users/reset-password/confirm', passwordResetConfirmRequest);
        } catch (error) {
            console.error('Error resetting password:', error.message || error);
            throw error;
        }
    },

    // Récupérer un utilisateur par nom d'utilisateur
    getUserByUsername: async (username) => {
        try {
            const response = await apiInstance.get(`/users/getUsername/${username}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user by username:', error.message || error);
            throw error;
        }
    },

    // Récupérer un utilisateur par numéro de téléphone
    getUserByPhoneNumber: async (phoneNumber) => {
        try {
            const response = await apiInstance.get(`/users/getPhone/${phoneNumber}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user by phone number:', error.message || error);
            throw error;
        }
    },

    // Récupérer des utilisateurs par ville
    getUsersByCity: async (city) => {
        try {
            const response = await apiInstance.get(`/users/getCity/${city}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users by city:', error.message || error);
            throw error;
        }
    },

    // Récupérer des utilisateurs par pays
    getUsersByCountry: async (country) => {
        try {
            const response = await apiInstance.get(`/users/getCountry/${country}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching users by country:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les utilisateurs désactivés
    getAllDisabledUsers: async () => {
        try {
            const response = await apiInstance.get('/users/disabled');
            return response.data;
        } catch (error) {
            console.error('Error fetching disabled users:', error.message || error);
            throw error;
        }
    },

    // Activer un utilisateur
    enableUser: async (id) => {
        try {
            const response = await apiInstance.put(`/users/enable/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error enabling user:', error.message || error);
            throw error;
        }
    },

    // Récupérer un utilisateur par useRef
    getUserByUseRef: async (useRef) => {
        try {
            const response = await apiInstance.get(`/users/getUseRef/${useRef}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user by useRef:', error.message || error);
            throw error;
        }
    },

    // Envoyer un rappel du nom d'utilisateur par email
    sendUsernameReminder: async (email) => {
        try {
            await apiInstance.post('/users/username/send-mail', { email });
        } catch (error) {
            console.error('Error sending username reminder:', error.message || error);
            throw error;
        }
    },
    // Récupérer tous les quartiers
    getAllNeighborhoods: async () => {
        try {
            const response = await apiInstance.get('/users/neighborhoods');
            return response.data;
        } catch (error) {
            console.error('Error fetching neighborhoods:', error.message || error);
            throw error;
        }
    },

};

export default UserService;